// Copy for the auth screens, used as t("ui.auth.*"). Field errors keep using the existing errors.* and auth.login.* keys.
export default {
  login: {
    title: "ورود به فونتا",
    subtitle: "با شماره موبایل و رمز عبورتون وارد بشین.",
    forgot: "رمز عبور خود را فراموش کرده‌اید؟",
    switchText: "هنوز حساب ندارین؟",
    switchCta: "ثبت‌نام",
  },
  register: {
    title: "ساخت حساب فونتا",
    subtitle: "فقط یه شماره موبایل و یه رمز عبور لازمه.",
    passwordHint: "حداقل ۸ کاراکتر",
    confirmation: "تکرار رمز عبور",
    switchText: "قبلاً حساب ساختین؟",
    switchCta: "ورود",
  },
  forgot: {
    title: "رمز عبورتون یادتون رفته؟",
    subtitle: "نگران نباشین. به دایرکت اینستاگرام فونتا پیام بدین، پشتیبانی کمکتون می‌کنه رمز عبور حسابتون رو برگردونین.",
    cta: "پیام به پشتیبانی در اینستاگرام",
    switchText: "هنوز حساب ندارین؟",
    switchCta: "ثبت‌نام",
  },
  fields: {
    mobile: "شماره موبایل",
    password: "رمز عبور",
    showPassword: "نمایش رمز عبور",
  },
  pitch: {
    title: "با پرو، همه چیز فونتا باز می‌شه",
    body: "وارد حسابتون بشین و پرو رو بخرین یا تمدید کنین.",
  },
  footer: {
    home: "بازگشت به خانه",
    language: "زبان",
  },
  languages: {
    fa: "فارسی",
    en: "English",
  },
};
